import axios from './axiosInstance'
import constants from '../constants'
import { isAuthenticated } from '../utils/authSession'

export default async function getBillingHistory(app) {
  const URL = `${constants.customerDomain}apps/${app.id}/invoices`
  try {
    if (isAuthenticated()) {
      const res = await axios.get(URL)
      return res.data
    }
  } catch (error) {
    let errorObject = error
    if (error.response !== undefined && error.response.data !== undefined)
      errorObject = error.response.data

    return errorObject
  }
  return false // Not authenticated — the call was never made
}

export async function getInvoice(app, invoiceId) {
  const URL = `${constants.customerDomain}apps/${app.id}/invoices/${invoiceId}/download`

  return axios({
    method: 'get',
    url: URL,
    responseType: 'blob',
  })
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      link.download = `CometChat_Invoice_${invoiceId}`

      document.body.appendChild(link)

      link.click()
      setTimeout(function fn() {
        window.URL.revokeObjectURL(link)
      }, 200)
      return response.data
    })
    .catch(() => {
      const err = { error: 'You Invoice cannot be downloaded. Please try again.' }
      return err
    })
}
